import { instance } from "../libs/client";

class CalculateService {
  async calculeteData(data) {
    const response = await instance.post("food/create", data);
    return response;
  }

  async response(data) {
    const response = await instance.post("food/calculate", data);
    return response;
  }

  async result(data) {
    const response = await instance.post("food/order-end", data);
    return response;
  }
}

const calculateService = new CalculateService();
export { calculateService };
